import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { BeheerButton } from '../ui/BeheerButton';
import { useDb } from '../../hooks/useDb';
import { useBoot } from '../../contexts/BootContext';
const BEHEER_LINKS = [{
  to: '/beheer/logboek',
  label: 'Logboek',
  hint: 'wat en waarom'
}, {
  to: '/beheer/agents',
  label: 'Agents',
  hint: 'wie mag wat'
}, {
  to: '/beheer/geheugen',
  label: 'Geheugen',
  hint: 'wat Anna weet'
}, {
  to: '/beheer/huis',
  label: 'Huis',
  hint: 'kamers, camera’s'
}, {
  to: '/beheer/systeem',
  label: 'Systeem',
  hint: 'diensten, tests'
}, {
  to: '/beheer/anna',
  label: 'Anna',
  hint: 'toon, stem, modi'
}];
export function BeheerMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const lastLog = useDb(t => t.log[t.log.length - 1]);
  const {
    replay
  } = useBoot();
  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('pointerdown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return <div ref={ref} className="relative" data-id="element-1419" data-mp="1e42ubhihjvh7">
      <BeheerButton size="wall" onClick={() => setOpen(v => !v)} data-id="element-1420" data-mp="197ksoqigcd93" />
      <AnimatePresence data-id="element-1421" data-mp="195807jf2ikhs">
        {open && <motion.div role="dialog" aria-label="Beheer" initial={{
        opacity: 0,
        y: 6,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 6,
        scale: 0.97
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute bottom-full right-0 z-40 mb-3 w-[520px] origin-bottom-right rounded-3xl border border-white/10 bg-night-900 p-6" data-id="element-1422" data-mp="1nx0hi0yfa8m5">
            <p className="text-[24px] font-semibold text-ink" data-id="element-1423" data-mp="2vhno2whvugup">Beheer</p>
            <nav aria-label="Beheer" className="mt-4 grid grid-cols-2 gap-2" data-id="element-1424" data-mp="2vfszn87ek6lv">
              {BEHEER_LINKS.map(l => <Link key={l.to} to={l.to} className="flex min-h-[84px] flex-col justify-center rounded-2xl bg-white/[0.05] px-5 py-3 text-[22px] font-medium text-ink transition-colors duration-150 hover:bg-white/[0.1]" data-id="element-1425" data-mp="34a7nw09wurh4">
                  {l.label}
                  <span className="text-[17px] font-normal text-ink-muted" data-id="element-1426" data-mp="2gk4yjrxdrzm7">{l.hint}</span>
                </Link>)}
            </nav>
            {lastLog && <p className="mt-4 border-t border-white/[0.07] pt-4 text-[22px] leading-snug text-ink-muted" data-id="element-1427" data-mp="3rztpsvho3kst">
                Laatst in het logboek: <span className="text-ink-soft" data-id="element-1428" data-mp="spj61pfq0kx">{lastLog.time} · {lastLog.summary}</span>
              </p>}
            <div className="mt-3 flex items-center justify-between gap-4" data-id="element-1429" data-mp="aw4cnugg78rp">
              <Link to="/spec" className="text-[20px] text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-1430" data-mp="5y2t78f417fp">
                Spec &amp; Stijl
              </Link>
              <button type="button" onClick={() => {
            setOpen(false);
            replay();
          }} className="text-[20px] text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-1431" data-mp="3tbeu6df369ye">
                Opstart opnieuw
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}